import { memo, useState } from "react";

import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import dayjs from "utility/dayjs";

import Abstract from "./Abstract";

// -----------------------------------------------------------------------------

const OrganizationFindingTimeRow = memo(function OrganizationFindingTimeRow({
  eventTime,
  createTime,
}: OrganizationFindingTimeRowProps): JSX.Element {
  return (
    <Abstract label="Time">
      <Typography variant="body1">
        Happened <TimeToolTip date={eventTime} />, detected{" "}
        <TimeToolTip date={createTime} />.
      </Typography>
    </Abstract>
  );
});

export default OrganizationFindingTimeRow;

// -----------------------------------------------------------------------------

function TimeToolTip({ date }: { date: Date }): JSX.Element {
  const [show, setShow] = useState(false);

  return (
    <Tooltip
      title={
        <>
          {date.toLocaleString()}
          <br />({date.toISOString()})
        </>
      }
      open={show}
      onOpen={() => setShow(true)}
      onClose={() => setShow(false)}
      enterTouchDelay={0}
      placement="top"
    >
      <span
        style={{ borderBottomWidth: 1, borderBottomStyle: "dotted" }}
        onClick={() => setShow(true)}
      >
        {dayjs(date).fromNow()}
      </span>
    </Tooltip>
  );
}

// -----------------------------------------------------------------------------

interface OrganizationFindingTimeRowProps {
  eventTime: Date;
  createTime: Date;
}
